import React, { useState, useEffect } from 'react';
import { Edit as ReactAdminEdit, ListButton, ShowButton, useEditContext, useResourceDefinition, useTranslate, useGetResourceLabel } from 'react-admin';

import CardActions from '../layout/CardActions';
import Breadcrumb from '../layout/Breadcrumb';

const EditActions = ({ className, children, breadcrumb }) => {
	const { resource, record } = useEditContext();
	const { hasList, hasShow } = useResourceDefinition({ resource });
	const getResourceLabel = useGetResourceLabel();
	const [icon, setIcon] = useState(null);
	const translate = useTranslate();

	useEffect(() => {
		async function getIcon() {
			try {
				const moduleResource = await import(`../../${resource}`);
				if (moduleResource?.default?.icon) {
					setIcon(<moduleResource.default.icon />);
				}
			} catch (e) {
				console.error(e);
			}
		}

		if (resource) {
			getIcon();
		}
	}, [resource]);

	const breadcrumbPath = [
		{ url: `/${resource}`, title: translate(`resources.${resource}.name`, { smart_count: 2, _: getResourceLabel(resource, 2) }), isActive: false, icon },
		{
			url: record ? `/${resource}/${record.id}/show` : '',
			title: record ? (record.name ? record.name : record.id) : '',
			isActive: false
		},
		{
			url: record ? `/${resource}/${record.id}` : '',
			title: translate('ra.action.edit'),
			isActive: true
		}
	];

	return (
		<CardActions className={className}>
			<Breadcrumb path={breadcrumb || breadcrumbPath} />
			<div>
				{children}
				{hasList && <ListButton />}
				{hasShow && <ShowButton record={record} />}
			</div>
		</CardActions>
	);
};


const Edit = ({ actions = <EditActions />, mutationMode = 'pessimistic', ...props }) => (
	<ReactAdminEdit actions={actions} mutationMode={mutationMode} {...props} />
);

export default Edit;
export { EditActions };